import { render, staticRenderFns } from "./CostRecord.vue?vue&type=template&id=77a2dc2b&scoped=true&"
import script from "./CostRecord.vue?vue&type=script&lang=js&"
export * from "./CostRecord.vue?vue&type=script&lang=js&"
import style0 from "./CostRecord.vue?vue&type=style&index=0&id=77a2dc2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a2dc2b",
  null
  
)

export default component.exports